import applyItaliaConfig from 'design-comuni-plone-theme/config/italiaConfig';

export default function applyConfig(config) {
  return applyItaliaConfig(config);
}
